/* eslint-disable */
<template>
  <div class="w-100 d-flex justify-content-between">
    <div class="summary-product-item">{{product.name}}</div>
    <div v-if="siteBookingSettingDisplayServicePrices">{{currencySymbol}}{{product.amount.toFixed(2).toString()}}</div>
  </div>
</template>

<script>
/* eslint-disable */
  import { CountryCacheMixin } from '@/mixins/Booking/CountryCacheMixin'
  import { SiteBookingSettingMixin } from '@/mixins/Booking/SiteBookingSettingMixin';

  export default {
    name: 'SummaryProductItem',
    mixins: [CountryCacheMixin, SiteBookingSettingMixin],
    props: {
      product: Object
    }
  }   
</script>
